// Skills by Evaluator: every grader's Position Skills marks side by side (GM / leadership review).
import { SKILL_SLOTS, SPLIT_GAP } from "./coreFactors";
import { skillsFor } from "./positionSkills";

export const SKILLS_REVIEW_ROLES = ["super_admin", "athletic_director", "deputy_ad", "gm", "head_coach", "chief_of_staff"];
const ok = (x) => typeof x === "number" && x >= 1 && x <= 5;
const mean = (v) => (v.length ? v.reduce((s, x) => s + x, 0) / v.length : null);
export const fmtGrade = (v) => (v == null ? "—" : Number.isInteger(v) ? String(v) : (Math.round(v * 10) / 10).toFixed(1));

// rows: one per position skill with each evaluator's mark, the average and the gap (high − low).
// bySlot: each evaluator's average; spread: gap between the highest and lowest evaluator average; splits: skills 2+ apart.
export function skillGrid(slots, position, cfg) {
  const rows = skillsFor(position, cfg).map(({ key, label }) => {
    const vals = Object.fromEntries(SKILL_SLOTS.map(([s]) => [s, slots?.[s]?.factors?.[key]]).filter(([, v]) => ok(v)));
    const v = Object.values(vals);
    return { key, label, vals, avg: mean(v), gap: v.length > 1 ? Math.max(...v) - Math.min(...v) : null };
  });
  const bySlot = Object.fromEntries(SKILL_SLOTS.map(([s]) => [s, mean(rows.map((r) => r.vals[s]).filter(ok))]));
  const avgs = Object.values(bySlot).filter((x) => x != null);
  return {
    rows, bySlot,
    avg: mean(rows.map((r) => r.avg).filter((x) => x != null)),
    spread: avgs.length > 1 ? Math.max(...avgs) - Math.min(...avgs) : null,
    splits: rows.filter((r) => r.gap != null && r.gap >= SPLIT_GAP).length,
    graders: avgs.length,
  };
}
